/**
 * Removes commas from a number string for validation
 * Example: "111,111,111" -> "111111111"
 */
export function removeCommas(value: string): string {
  return value.replace(/,/g, '');
}
